import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    getZonesIndicators(filter, sort, size, view) {
      const state = getState();
      const index = matchRequest(state, filter, view, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.zones : [];
    },
    canRetrieveZonesIndicators(filter, sort, size, view) {
      const state = getState();
      const index = matchRequest(state, filter, view, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.canLoadMore : true;
    },
    getRetrieveZonesIndicatorsIndex(filter, sort, size, view) {
      const state = getState();
      const index = matchRequest(state, filter, view, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.index : 0;
    },
    isRetrieveZonesIndicatorsRequestFailure(filter, sort, size, view) {
      const state = getState();
      const index = matchRequest(state, filter, view, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isFailure : false;
    },
    isRetrieveZonesIndicatorsRequestPending(filter, sort, size, view) {
      const state = getState();
      const index = matchRequest(state, filter, view, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isPending : false;
    },
    isRetrieveZonesIndicatorsRequestSuccess(filter, sort, size, view) {
      const state = getState();
      const index = matchRequest(state, filter, view, sort, size);
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
